module.exports = __webpack_public_path__ + "img/eclairage.d2a52f3d.svg";